import * as React from "react";
import { MarketplaceReleaseInstance, ReleaseRevision } from "../types/release";
import { Table } from "../../../newcomponents/table/table";
import { NGButton } from "../../../newcomponents/button/Button";
import { Modal, notification } from "antd";
import { DateString } from "../../../components/dateString";
import { request } from "../../../services/cpln";
import { formatStrings } from "../../../utils/time";
import { useDetailContext } from "../../../components/detail/detailContext";
import { Search } from "react-feather";
import { ViewModal } from "../../../components/modals/viewModal";

interface ReleaseRevisionTableItem extends ReleaseRevision {
  isLoadingRollback: boolean;
  isLoadingRollbackThis: boolean;
}

interface Props {
  release: MarketplaceReleaseInstance;
  revisions: ReleaseRevision[];
}
export const ReleaseRevisions: React.FC<Props> = ({ release, revisions }) => {
  const { fetchItem } = useDetailContext();

  const [isLoadingRollbackRevision, setIsLoadingRollbackRevision] = React.useState<number | null>(null);
  const [isLoadingRollback, setIsLoadingRollback] = React.useState(false);

  const [revisionToView, setRevisionToView] = React.useState<any>(null);

  async function handleRollback(revision: number) {
    Modal.confirm({
      title: "Are you sure?",
      content: `App release will be rolled back to the state at revision ${revision}.`,
      okText: "Rollback",
      okButtonProps: { type: "primary" },
      cancelText: "Cancel",
      cancelButtonProps: { type: "primary", disabled: isLoadingRollback },
      onOk: async () => {
        try {
          setIsLoadingRollbackRevision(revision);
          setIsLoadingRollback(true);
          const { data } = await request({
            service: "marketplace",
            method: "post",
            url: `/helm/rollback`,
            body: {
              org: release.org,
              name: release.name,
              revision: revision,
            },
          });
          console.log("response on rollback", data);
          notification.success({ message: "Success", description: "Rolled back release" });
          setIsLoadingRollbackRevision(null);
          setIsLoadingRollback(false);
          if (fetchItem) {
            fetchItem();
          }
        } catch (e) {
          setIsLoadingRollbackRevision(null);
          setIsLoadingRollback(false);
          console.log(e);
          notification.warning({ message: "Failed", description: e.message });
        }
      },
    });
  }

  const releaseStateDeploymentTableItems: ReleaseRevisionTableItem[] = revisions
    .toSorted((a, b) => {
      if (a.version > b.version) return -1;
      if (b.version > a.version) return 1;
      return 0;
    })
    .map((d) => {
      return {
        ...d,
        isLoadingRollback: isLoadingRollback,
        isLoadingRollbackThis: isLoadingRollbackRevision === d.version,
      };
    });

  return (
    //
    <>
      <Table<ReleaseRevisionTableItem>
        columns={[
          {
            id: "version",
            label: "Revision",
            size: 100,
          },
          {
            id: "info.description",
            label: "Description",
            cell: ({ row, getValue }) => {
              return (
                <div className="flex items-center gap-2">
                  <Search
                    size={16}
                    className="cursor-pointer color-link"
                    onClick={() => setRevisionToView(row.original)}
                  />
                  <span>{getValue()}</span>
                </div>
              );
            },
          },
          {
            id: "info.status",
            label: "Status",
          },
          {
            id: "info.lastDeployed",
            label: "Updated",
            cell: ({ getValue }) => {
              return <DateString iso={getValue()} format={formatStrings.log} />;
            },
          },
          {
            id: "actions",
            label: "Actions",
            cell: (p) => {
              const item = p.row.original;

              if (item.version === releaseStateDeploymentTableItems[0].version) {
                return null;
              }

              if (item.info.status === "failed") {
                return null;
              }

              return (
                <NGButton
                  variant="secondary"
                  onClick={() => handleRollback(item.version)}
                  size={"small"}
                  disabled={item.isLoadingRollback}
                  loading={item.isLoadingRollbackThis}
                >
                  Rollback
                </NGButton>
              );
            },
          },
        ]}
        data={releaseStateDeploymentTableItems}
        title={"Revisions"}
        tableId="release-revisions-update3"
        hideSettings
      />
      {revisionToView ? (
        <ViewModal
          filename={`Revision`}
          onClose={() => setRevisionToView(null)}
          title="Revision"
          visible={!!revisionToView}
          initialFormat={"yaml"}
          noSlim
          object={revisionToView}
        />
      ) : null}
    </>
  );
};
